/**
 * Design: Leaning Meter / Leaning Mini + AI Estimate Chip (screenshots/18–21). Pure DOM (no chart lib needed).
 * Renders both leaning states: estimated and building ("⌛ Building · 3 of 5 quotes"). Icons: lucide.
 */
import { Hourglass, Sparkles } from "lucide-react";
import { leaningBasis, leaningLabel, leaningToPct, type LeaningEstimate } from "./types";

export function LeaningMeter({ estimate, size = "full" }: { estimate: LeaningEstimate; size?: "full" | "mini" }) {
  if (estimate.status === "building") {
    return <span className="leaning leaning--building"><Hourglass size={12} aria-hidden />Building · {estimate.quotesUsed} of {estimate.quotesRequired} quotes</span>;
  }
  const pos = leaningToPct(estimate.score);
  const low = leaningToPct(estimate.low);
  const high = leaningToPct(estimate.high);
  const label = leaningLabel(estimate.score);
  return (
    <div className={`leaning leaning--${size}`} role="img"
      aria-label={`AI estimate: ${label}, ${estimate.confidence} confidence. ${leaningBasis(estimate)}`}>
      <div className="leaning__track">
        <span className="leaning__band" style={{ left: `${low}%`, width: `${high - low}%` }} />
        <span className="leaning__marker" style={{ left: `${pos}%` }} />
      </div>
      {size === "full" ? (
        <div className="leaning__scale"><span>Progressive</span><span>Moderate</span><span>Conservative</span></div>
      ) : (
        <span className="leaning__mini-label">{label} · {estimate.confidence}</span>
      )}
    </div>
  );
}

export function AiEstimateChip({ label = "AI estimate" }: { label?: string }) {
  return <span className="ai-chip"><Sparkles size={11} aria-hidden />{label}</span>;
}
